var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmployer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_42",
    "data-name": "Layer 42",
    transform: "translate(-3 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1927",
    "data-name": "Path 1927",
    d: "M96.1,33H29.9C15.062,33,3,44.525,3,58.672V92.211H123V58.672C123,44.525,110.938,33,96.1,33ZM71.09,37.229,69.972,49.918H56.028L54.91,37.229Zm.186,34.766L63,78.91l-8.276-6.915,1.324-17.848h13.9ZM7.138,87.982V58.672c0-11.821,10.2-21.443,22.759-21.443H50.772l1.283,14.8L50.586,73.877,63,84.45,75.414,73.877,73.945,52.032l1.283-14.8H96.1c12.559,0,22.759,9.622,22.759,21.443v29.31Z",
    transform: "translate(0 30.789)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1928",
    "data-name": "Path 1928",
    d: "M47.606,62.211A29.606,29.606,0,1,0,18,32.606,29.606,29.606,0,0,0,47.606,62.211ZM32.147,52.7a25.249,25.249,0,0,1,30.917,0A25.249,25.249,0,0,1,32.147,52.7ZM47.606,7.229A25.376,25.376,0,0,1,66.215,49.8,29.479,29.479,0,0,0,29,49.8,25.376,25.376,0,0,1,47.606,7.229Z",
    transform: "translate(15.394 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployer);
export default __webpack_public_path__ + "static/media/Employer.d3d7649dc114f8301780bf8dbd623dc1.svg";
export { ForwardRef as ReactComponent };